
import axios from 'axios';

export default {
  name: 'IndividualHours',
  props: {
    dataUrl: {type: String, required: true},
    semesterId: {type: Number, required: true},
    courseBaseUrl: {type: String, required: true},
  },
  data() {
    return {
      isBusy: false,
      error: false,
      formatDurationsAsHours: false,
      fields: [
        {key: 'contractType', label: 'Vertrag'},
        {key: 'coursesCL1', label: 'Titel VGS 1',
          headerTitle: 'Veranstaltungstitel Vergütungsstufe 1', tdClass: 'align-middle'},
        {key: 'coursesCL2', label: 'Titel VGS 2',
          headerTitle: 'Veranstaltungstitel Vergütungsstufe 2', tdClass: 'align-middle'},
        {key: 'calculatedWorkloadCL1', label: 'VGS 1', headerTitle: 'Vergütungsstufe 1',
          formatter: ({value}) => this.formatDuration(value), tdClass: 'text-end'},
        {key: 'calculatedWorkloadCL2', label: 'VGS 2', headerTitle: 'Vergütungsstufe 2',
          formatter: ({value}) => this.formatDuration(value), tdClass: 'text-end'},
        {key: 'calculatedWorkloadTotal', label: 'VGS  1&2', headerTitle: 'Summe Vergütungsstufen',
          formatter: ({value}) => this.formatDuration(value), tdClass: 'text-end'},
      ],
      items: [],
    };
  },
  computed: {
    columnSums() {
      const result = {'compensationLevel1': 0, 'compensationLevel2': 0, 'compensationLevels': 0};
      this.items.forEach(function(row) {
        result.compensationLevel1 += row['calculatedWorkloadCL1'];
        result.compensationLevel2 += row['calculatedWorkloadCL2'];
        result.compensationLevels += row['calculatedWorkloadTotal'];
      });
      return result;
    },
    durationFormatTooltipText(){
      return `Zeitdauern in ${this.formatDurationsAsHours ? 'Stunden und Minuten' : 'Stunden'} anzeigen`;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isBusy = true;

      // reset error state
      this.error = false;

      // fetch data
      axios.get(this.dataUrl, {
        params: {
          semester: this.semesterId,
        },
      }).then((response) => {
        this.items = response.data;
      }).catch((error) => {
        this.error = error;
        this.items = [];
      }).finally(() => {
        this.isBusy =false;
      });
    },
    weekhourSum(items) {
      return items.reduce((sum, currentItem) => sum + currentItem['calculatedWorkload'], 0);
    },
    copyTitles(value) {
      const uniqueTitles = [...new Set(value)];
      uniqueTitles.sort((a, b) => a.localeCompare(b, 'de-DE'));
      navigator.clipboard.writeText(uniqueTitles.join('; '));
      alert('Die Veranstaltungstitel wurden kopiert.');
    },
    formatDecimalNumber(value) {
      if (value === null) return '';
      return Number(value).toLocaleString('de-De', {maximumFractionDigits: 2, minimumFractionDigits: 2});
    },
    formatDuration(minutes) {
      if (minutes === null) return '';
      if (this.formatDurationsAsHours) {
        return this.formatDecimalNumber(minutes / 60);
      }
      return Math.trunc(minutes / 60) + ':' + String(Math.abs(minutes % 60)).padStart(2, '0');
    },
  },
};
